var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('label',{attrs:{"for":`scope-field-${_vm.kebabLabel}`},domProps:{"textContent":_vm._s(_vm.sentenceLabel)}}),_vm._v(" "),_c('FlatPickr',{staticStyle:{"margin-bottom":"0"},attrs:{"id":`scope-field-${_vm.kebabLabel}`,"value":null},on:{"input":_vm.handleDateAdded}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }